import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE, Language } from '../constants';
import { languageSchema } from '../schemas';

export const useLanguage = (): Language => {
  const { i18n } = useTranslation();

  const languageResult = languageSchema.safeParse(i18n.resolvedLanguage);

  if (languageResult.success) {
    return languageResult.data;
  }

  return DEFAULT_LANGUAGE;
};
